export default {
  'menu.dashboard.monitorScreen': '监控大屏',
};
